var _defineProperty = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var icons = require('iconoir-react');

var React = require('react');

var newIcons = {};

var _loop = function _loop() {
  var key = _Object$keys[_i];

  newIcons[key] = function (props) {
    return React.createElement(icons[key], _objectSpread({
      width: '1em',
      height: '1em',
      className: ['anticon', props.className].filter(Boolean).join(' ')
    }, props));
  };
};

for (var _i = 0, _Object$keys = Object.keys(icons); _i < _Object$keys.length; _i++) {
  _loop();
}

module.exports = newIcons;